import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { SalaryDraftFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SalaryDraftRejectFormContainerProps } from "models/propTypes/salaryPropTypes";
import * as Yup from "yup";
//#endregion
//#region components
import SalaryDraftRejectForm from "./rejectForm";
import { useSalaryService } from "serviceHooks";
//#endregion

const SalaryDraftRejectFormContainer: ForwardRefRenderFunction<FormHandles, SalaryDraftRejectFormContainerProps> = (
  props,
  ref
) => {
  const salaryService = useSalaryService();
  const validationSchema = Yup.object<SalaryDraftFormTypes.Reject>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: SalaryDraftFormTypes.Reject) => {
    return salaryService.rejectSalaryDraft(props.salaryDraftId, values.message);
  };

  return (
    <SalaryDraftRejectForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(SalaryDraftRejectFormContainer);
